import { Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ConnectionStatus } from '@vendasta/platform-integrations';
import { MatButton, MatIconButton } from '@angular/material/button';

@Component({
  selector: 'platform-integration-passwordfield',
  imports: [
    TranslateModule,
    CommonModule,
    MatIcon,
    CdkCopyToClipboard,
    GalaxyFormFieldModule,
    MatIconButton,
    MatButton,
    FormsModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PasswordFieldComponent,
    },
  ],
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
})
export class PasswordFieldComponent implements ControlValueAccessor {
  @Input() value = '';
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() required = false;
  @Input() isInstructionPage = false;
  private snackbarService = inject(SnackbarService);
  protected readonly ConnectionStatus = ConnectionStatus;
  notifyCopy(): void {
    this.snackbarService.openSuccessSnack('COMMON.COPY_TO_CLIPBOARD', {
      action: 'close',
      duration: 3000,
    });
  }
  onChange = (_value: string) => {
    return;
  };
  onTouched = () => {
    return;
  };
  private touched = false;

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(onChangeFn: any): void {
    this.onChange = onChangeFn;
  }

  registerOnTouched(onTouchedFn: any): void {
    this.onTouched = onTouchedFn;
  }
}
